import React from "react";
import { IconType } from "react-icons";

interface IconButtonProps {
  icon: IconType;
  type?: "button" | "submit" | "reset";
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "primary" | "secondary" | "success" | "danger" | "warning" | { bg: string; text: string };
  reverseColors?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon: Icon,
  type = "button",
  size = "md",
  variant = "primary",
  reverseColors = false,
  onClick,
}) => {
  const sizeClass = () => {
    switch (size) {
      case "sm":
        return "p-[0.5rem] text-[1rem] rounded-[0.5rem]";
      case "md":
        return "p-[0.5625rem] text-[1.125rem] rounded-[0.5625rem]";
      case "lg":
        return "p-[0.625rem] text-[1.25rem] rounded-[0.625rem]";
      case "xl":
        return "p-[1.25rem] text-[1.5rem] rounded-[0.75rem]";
    }
  };

  const variantClass = () => {
    if (typeof variant !== "string") {
      if (reverseColors) return "text-" + variant.bg + " " + "bg-" + variant.text;
      return "bg-" + variant.bg + " " + "text-" + variant.text;
    }

    if (!reverseColors) {
      switch (variant) {
        case "primary":
          return "bg-primary text-primary-foreground";
        case "secondary":
          return "bg-secondary text-secondary-foreground";
        case "success":
          return "bg-success text-success-foreground";
        case "danger":
          return "bg-danger text-danger-foreground";
        case "warning":
          return "bg-warning text-warning-foreground";
      }
    }

    // reversed colors
    switch (variant) {
      case "primary":
        return "text-primary bg-primary-foreground";
      case "secondary":
        return "text-secondary bg-secondary-foreground";
      case "success":
        return "text-success bg-success-foreground";
      case "danger":
        return "text-danger bg-danger-foreground";
      case "warning":
        return "text-warning bg-warning-foreground";
    }
  };

  return (
    <button type={type} className={[sizeClass(), variantClass()].join(" ")} onClick={onClick}>
      <Icon />
    </button>
  );
};

export default IconButton;
